var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
import { ConsolidationStatus, HandoffMethod, LabelType, PackageCondition, PackageDelayReasonType, PackageProblemReasonType, PackageStatus, PackageType, TripCSATReasonType, TripStatus, TripType, } from '@returnmates/client-core/src/graphql/generated/api';
import formatSnakeCaseToSentenceCase from '../utils/formatSnakeCaseToSentenceCase';
var statusColorsBg = {
    pendingColor: 'rgba(255, 212, 84, 0.15)',
    startPendingColor: 'rgba(255, 232, 124, 0.20)',
    completeColor: '#DBF6EC',
    cancelColor: 'rgba(228, 32, 0, 0.06)',
};
var statusColors = {
    pendingColor: '#E0B531',
    startPendingColor: '#F29D39',
    completeColor: '#4BD1A0',
    cancelColor: '#E42000',
};
export var methodMap = (_a = {},
    _a[HandoffMethod.DOORSTEP] = 'Leave on doorstep',
    _a[HandoffMethod.DIRECT] = 'Direct handoff',
    _a);
export var TRIP_METHOD_MAP = (_b = {},
    _b[HandoffMethod.DOORSTEP] = 'Doorstep',
    _b[HandoffMethod.DIRECT] = 'Direct',
    _b);
export var TRIP_STATUS_MAP = (_c = {},
    _c[TripStatus.PENDING] = 'Pending',
    _c[TripStatus.PENDING_API] = 'Pending (API)',
    _c[TripStatus.TASK_NOT_CREATED] = 'Task Not Created',
    _c[TripStatus.SCHEDULED] = 'Scheduled',
    _c[TripStatus.DRIVER_LAUNCHED] = 'Driver Launched',
    _c[TripStatus.IN_PROGRESS] = 'In Progress',
    _c[TripStatus.NO_LOCATION] = 'No Location',
    _c[TripStatus.COMPLETE] = 'Complete',
    _c[TripStatus.FAILED] = 'Failed',
    _c[TripStatus.CANCELED] = 'Canceled',
    _c);
export var PACKAGE_STATUS_MAP = (_d = {},
    _d[PackageStatus.PENDING] = 'Pending',
    _d[PackageStatus.CANCELED] = 'Canceled',
    _d[PackageStatus.FAILED] = 'Failed',
    _d[PackageStatus.RTS] = 'RTS',
    _d[PackageStatus.DRIVER_LAUNCHED] = 'Driver Launched',
    _d[PackageStatus.DRIVER_ARRIVING] = 'Driver Arriving',
    _d[PackageStatus.PICKED_UP] = 'Picked Up',
    _d[PackageStatus.RECEIVED] = 'Received',
    _d[PackageStatus.DEPARTED] = 'Departed',
    _d[PackageStatus.DELIVERED] = 'Delivered',
    _d[PackageStatus.CONSOLIDATED] = 'Consolidated',
    _d[PackageStatus.DELAYED] = 'Delayed',
    _d[PackageStatus.IN_CUSTODY] = 'In Custody',
    _d[PackageStatus.IN_TRANSIT] = 'In Transit',
    _d[PackageStatus.PROBLEM] = 'Problem',
    _d);
export var PACKAGE_DELAY_REASON_MAP = (_e = {},
    _e[PackageDelayReasonType.INVALID_ADDRESS] = 'Invalid Address',
    _e[PackageDelayReasonType.ON_HOLD_CUSTOMER_REQUEST] = 'On Hold (Customer Request)',
    _e[PackageDelayReasonType.LABEL_ISSUE] = 'Label Issue',
    _e[PackageDelayReasonType.HUB_MISSORT] = 'Hub Missort',
    _e[PackageDelayReasonType.MANIFESTED_BUT_NOT_RECEIVED] = 'Manifested But Not Received',
    _e);
export var PACKAGE_PROBLEM_REASON_MAP = (_f = {},
    _f[PackageProblemReasonType.INVALID_ADDRESS] = 'Invalid Address',
    _f[PackageProblemReasonType.NOT_RECEIVED_WITHIN_WINDOW] = 'Not Received Within Window',
    _f[PackageProblemReasonType.PACKAGE_LOST] = 'Package Lost',
    _f);
export var CONSOLIDATION_STATUS_MAP = (_g = {},
    _g[ConsolidationStatus.PENDING] = 'Pending',
    _g[ConsolidationStatus.PACKED] = 'Packed',
    _g[ConsolidationStatus.DEPARTED] = 'Departed',
    _g[ConsolidationStatus.SHIPPED] = 'Shipped',
    _g[ConsolidationStatus.RECEIVED] = 'Received',
    _g[ConsolidationStatus.IN_TRANSIT] = 'In Transit',
    _g[ConsolidationStatus.IN_CUSTODY] = 'In Custody',
    _g[ConsolidationStatus.DELAYED_MISSORT] = 'Delayed (Hub Missort)',
    _g);
export var INBOUND_CONSOLIDATION_STATUS_MAP = (_h = {},
    _h[ConsolidationStatus.PENDING] = 'Pending',
    _h[ConsolidationStatus.PACKED] = 'Packed',
    _h[ConsolidationStatus.DEPARTED] = 'Departed',
    _h[ConsolidationStatus.SHIPPED] = 'Delivered',
    _h);
export var OUTBOUND_CONSOLIDATION_STATUS_MAP = (_j = {},
    _j[ConsolidationStatus.PENDING] = 'Pending',
    _j[ConsolidationStatus.PACKED] = 'Packed',
    _j[ConsolidationStatus.IN_TRANSIT] = 'In Transit',
    _j[ConsolidationStatus.IN_CUSTODY] = 'In Custody',
    _j[ConsolidationStatus.RECEIVED] = 'Received',
    _j[ConsolidationStatus.DELAYED_MISSORT] = 'Delayed (Hub Missort)',
    _j);
export var consolidationStatusMap = function (status) {
    switch (status) {
        case ConsolidationStatus.PENDING:
            return 'Pending';
        case ConsolidationStatus.PACKED:
            return 'Packed';
        case ConsolidationStatus.DEPARTED:
            return 'Departed';
        case ConsolidationStatus.SHIPPED:
            return 'Delivered';
        case ConsolidationStatus.RECEIVED:
            return 'Received';
        case ConsolidationStatus.IN_TRANSIT:
            return 'In Transit';
        case ConsolidationStatus.IN_CUSTODY:
            return 'In Custody';
        case ConsolidationStatus.DELAYED_MISSORT:
            return 'Delayed (Hub Missort)';
        default:
            return status;
    }
};
export var CONSOLIDATION_STATUS_TO_PACKAGE_STATUS_MAP = (_k = {},
    _k[ConsolidationStatus.SHIPPED] = PackageStatus.DELIVERED,
    _k[ConsolidationStatus.DEPARTED] = PackageStatus.DEPARTED,
    _k[ConsolidationStatus.DELAYED_MISSORT] = PackageStatus.DELAYED,
    _k);
export var LABEL_TYPE_MAP = (_l = {},
    _l[LabelType.PHYSICAL] = 'Physical',
    _l[LabelType.DIGITAL] = 'Digital',
    _l[LabelType.AMAZON] = 'Amazon',
    _l[LabelType.CONSOLIDATED] = 'Consolidated',
    _l);
export var ADD_PACKAGE_LABEL_TYPE_MAP = (_m = {},
    _m[LabelType.PHYSICAL] = 'Physical',
    _m[LabelType.DIGITAL] = 'Digital',
    _m[LabelType.AMAZON] = 'Amazon',
    _m);
export var PACKAGE_CONDITION_MAP = (_o = {},
    _o[PackageCondition.OK] = 'OK',
    _o[PackageCondition.PENDING] = 'PENDING',
    _o[PackageCondition.DAMAGED] = 'DAMAGED',
    _o);
export var PACKAGE_CONDITION = (_p = {},
    _p[PackageCondition.OK] = 'Ok',
    _p[PackageCondition.PENDING] = 'Pending',
    _p[PackageCondition.DAMAGED] = 'Damaged',
    _p);
export var TRIP_TYPE_MAP = (_q = {},
    _q[TripType.PICKUP] = 'Pickup',
    _q[TripType.DROPOFF] = 'Delivery',
    _q);
export var PACKAGE_TYPE_MAP = (_r = {},
    _r[PackageType.PICKUP] = 'Pickup',
    _r[PackageType.DROPOFF] = 'Delivery',
    _r);
export function getStatusColorBg(status) {
    switch (status) {
        case TripStatus.DRIVER_LAUNCHED:
        case TripStatus.PENDING_API:
            return statusColorsBg.startPendingColor;
        case TripStatus.COMPLETE:
        case PackageStatus.DELIVERED:
        case PackageStatus.RECEIVED:
        case PackageStatus.DEPARTED:
        case ConsolidationStatus.DEPARTED:
            return statusColorsBg.completeColor;
        case TripStatus.CANCELED:
        case TripStatus.FAILED:
        case TripStatus.TASK_NOT_CREATED:
        case PackageStatus.CANCELED:
        case PackageStatus.FAILED:
        case PackageStatus.RTS:
        case ConsolidationStatus.DELAYED_MISSORT:
            return statusColorsBg.cancelColor;
        default:
            return statusColorsBg.pendingColor;
    }
}
export function getStatusColor(status) {
    switch (status) {
        case TripStatus.DRIVER_LAUNCHED:
        case TripStatus.PENDING_API:
            return statusColors.startPendingColor;
        case TripStatus.COMPLETE:
        case PackageStatus.DELIVERED:
        case PackageStatus.RECEIVED:
        case PackageStatus.DEPARTED:
        case ConsolidationStatus.DEPARTED:
            return statusColors.completeColor;
        case TripStatus.FAILED:
        case TripStatus.CANCELED:
        case TripStatus.TASK_NOT_CREATED:
        case PackageStatus.RTS:
            return statusColors.cancelColor;
        default:
            return statusColors.pendingColor;
    }
}
export var NEGATIVE_PICKUP_CSAT_REASON_TYPE_MAP = (_s = {},
    _s[TripCSATReasonType.DRIVER_WAS_UNPROFESSIONAL] = 'Driver was unprofessional',
    _s[TripCSATReasonType.INSTRUCTIONS_WERE_NOT_FOLLOWED] = 'Pickup Instructions were not followed',
    _s[TripCSATReasonType.NEVER_ATTEMPTED] = 'Never attempted',
    _s[TripCSATReasonType.WRONG_ITEM_PICKED_UP] = 'Wrong item picked up',
    _s[TripCSATReasonType.INACCURATE_ETA] = 'Inaccurate ETA',
    // Reasons offered on the public tracking page (Sep 2026)
    _s[TripCSATReasonType.WRONG_PICKUP_LOCATION] = 'Wrong pickup location',
    _s[TripCSATReasonType.DRIVER_WAS_LATE] = 'Late',
    _s[TripCSATReasonType.ITEMS_NOT_ALL_COLLECTED] = 'Items not all collected',
    _s[TripCSATReasonType.DRIVER_WAS_DISRUPTIVE] = 'Loud / disruptive',
    _s[TripCSATReasonType.ITEMS_LEFT_BEHIND] = 'Left items behind',
    _s);
export var NEGATIVE_DELIVERY_CSAT_REASON_TYPE_MAP = (_t = {},
    _t[TripCSATReasonType.DRIVER_WAS_UNPROFESSIONAL] = 'Driver was unprofessional',
    _t[TripCSATReasonType.INSTRUCTIONS_WERE_NOT_FOLLOWED] = 'Delivery Instructions were not followed',
    _t[TripCSATReasonType.PACKAGE_IS_MISSING] = 'Package is missing',
    _t[TripCSATReasonType.DELIVERED_TO_WRONG_ADDRESS] = 'Delivered to wrong address',
    _t[TripCSATReasonType.PACKAGE_WAS_DAMAGED] = 'Package was damaged',
    _t[TripCSATReasonType.INACCURATE_ETA] = 'Inaccurate ETA',
    // Reasons offered on the public tracking page (Sep 2026)
    _t[TripCSATReasonType.WRONG_DROPOFF_LOCATION] = 'Wrong dropoff location',
    _t[TripCSATReasonType.MISSING_DROPOFF_LOCATION] = 'Missing dropoff location',
    _t[TripCSATReasonType.PACKAGE_LEFT_IN_BAD_SPOT] = 'Driver put package in bad spot',
    _t);
export var POSITIVE_CSAT_REASON_TYPE_MAP = (_u = {},
    _u[TripCSATReasonType.DRIVER_WAS_FRIENDLY] = 'Driver was friendly',
    _u[TripCSATReasonType.DRIVER_ARRIVED_ON_TIME] = function (_, action) { return "Package was ".concat(action, " on time"); },
    _u[TripCSATReasonType.DRIVER_WENT_ABOVE_AND_BEYOND] = 'Driver went above and beyond',
    _u[TripCSATReasonType.INSTRUCTIONS_WERE_FOLLOWED] = function (type) { return "".concat(type, " instructions were followed"); },
    _u[TripCSATReasonType.PACKAGE_WAS_HANDLED_WITH_CARE] = function (_, action) {
        return "Package was ".concat(action, " with care");
    },
    _u[TripCSATReasonType.DRIVER_WAS_RESPECTFUL_OF_MY_PROPERTY] = 'Driver was respectful of my property ',
    _u);
export var CSAT_REASON_TYPE_MAP = Object.keys(TripCSATReasonType).reduce(function (acc, res) {
    var _a;
    return __assign(__assign({}, acc), (_a = {}, _a[res] = formatSnakeCaseToSentenceCase(res), _a[TripCSATReasonType.INACCURATE_ETA] = 'Inaccurate ETA', _a));
}, {});
//# sourceMappingURL=trip.js.map